module.exports = __webpack_public_path__ + "static/about_top-a66991ad205f2bdc464352e912f37ec8.webm";